import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export function PdfIcon(props: SvgIconProps) {
  return (
    <SvgIcon width='64' height='73' viewBox='0 0 64 73' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M5.78 0C2.59 0 0 2.59 0 5.78v61.28c0 3.19 2.59 5.78 5.78 5.78h52.09c3.19 0 5.78-2.59 5.78-5.78V22.6L42.14 0H5.78Z'
        fill='#F44336'
      />
      <path d='M63.65 22.68v1.14H49.1s-7.19-1.43-6.98-7.63c0 0 .24 6.5 6.84 6.5h14.69Z' fill='#C62828' />
      <path opacity={0.5} d='M42.16 0v15.6c0 1.89 1.26 6.59 6.94 6.59h14.57L42.16 0Z' fill='white' />
      <text x='16' y='54' fontSize='22' fontWeight='bold' fill='white' fontFamily='Arial, Helvetica, sans-serif'>
        PDF
      </text>
    </SvgIcon>
  );
}
